import { ColumnSettings } from '@mode/legacy/data-access-model-js';

class ColumnOptionsService {
  public constructor() {}

  public columnType(columnSettings: ColumnSettings, colKey) {
    const colSettings = columnSettings && columnSettings[colKey];

    return colSettings && colSettings.hasOwnProperty('type') ? colSettings['type'] : null;
  }

  public columnTypeVariant(columnSettings: ColumnSettings, colKey) {
    const colTypeSettings = this.columnTypeSettings(columnSettings, colKey);

    return colTypeSettings && colTypeSettings.hasOwnProperty('type') ? colTypeSettings['type'] : null;
  }

  public columnTypeSettings(columnSettings: ColumnSettings, colKey) {
    const colType = this.columnType(columnSettings, colKey);
    const colSettings = columnSettings && columnSettings[colKey];

    return colSettings && colSettings.hasOwnProperty(colType) ? colSettings[colType] : null;
  }

  public columnTypeSetting(columnSettings: ColumnSettings, colKey, settingKey) {
    const colSettings = columnSettings && columnSettings[colKey];
    const colTypeSettings = colSettings && colSettings[colSettings['type']];

    return colTypeSettings && colTypeSettings.hasOwnProperty(settingKey) ? colTypeSettings[settingKey] : null;
  }
}

export default ColumnOptionsService;
